
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 14 14" fill="currentColor">
	<path fill-rule="evenodd" clip-rule="evenodd"
		d="M15.8219 10.035L12.8439 7.18424L6.15548 13.9116L5.47839 17.5158L9.1334 16.7625L15.8219 10.035ZM16.7382 9.11336L13.7603 6.2626L14.0756 5.94543C14.0919 5.93191 14.1078 5.91749 14.123 5.90216C14.5106 5.51233 15.0295 5.29395 15.5844 5.28725C16.1366 5.28104 16.6636 5.48602 17.0611 5.86647C17.8811 6.6515 17.8973 7.94468 17.0973 8.74949C17.0855 8.76139 17.0742 8.77362 17.0635 8.78616L16.7382 9.11336ZM12.8764 19.001H18.3439C18.7062 19.001 19 18.7127 19 18.3572C19 18.0017 18.7062 17.7135 18.3439 17.7135H12.8764C12.5141 17.7135 12.2204 18.0017 12.2204 18.3572C12.2204 18.7127 12.5141 19.001 12.8764 19.001Z" />
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Pen',
    }) as DefineComponent
    </script>
    